import { Navigate } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_USERGROUP_USER } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsTabletAndAbove } from '@sorare/core/src/hooks/device/useIsTabletAndAbove';

import type { PageParams } from './__generated__/routeParams';

const PlayProChampionshipUserGroupPage = () => {
  const tabletAndAbove = useIsTabletAndAbove();
  const { generateSportContextPath } = useSportContext();
  const { userGroup: userGroupSlug, eventType } = useTypedParams<PageParams>();
  const { currentUser } = useCurrentUserContext();

  if (!tabletAndAbove) {
    return null;
  }

  return (
    <Navigate
      to={generateSportContextPath(
        ANY_SPORT_PLAY_EVENTTYPE_CHAMPIONSHIP_USERGROUP_USER,
        {
          params: {
            eventType: eventType.toLowerCase(),
            userGroup: userGroupSlug,
            user: currentUser?.slug ?? '',
          },
        }
      )}
      replace
    />
  );
};

export default PlayProChampionshipUserGroupPage;
